/**
 * SRS 间隔重复 — 基于 ts-fsrs
 *
 * 对齐 features.md 7.1-7.7：FSRS 算法
 * 对齐 architecture.md §九：FSRS 四档评分
 */

import type { Grade, Card } from 'ts-fsrs';
import { fsrs, generatorParameters, createEmptyCard } from 'ts-fsrs';

// FSRS 参数（默认参数，后续可调优）
const params = generatorParameters({ enable_fuzz: true });
const f = fsrs(params);

/** 评分等级 */
export type SrsGrade = Grade; // 0=Again, 1=Hard, 2=Good, 3=Easy

/** 评分选项 */
export const GRADE_OPTIONS: { grade: SrsGrade; label: string; color: string }[] = [
  { grade: 1, label: '重来', color: 'bg-error text-white' },
  { grade: 2, label: '困难', color: 'bg-camel text-white' },
  { grade: 3, label: '良好', color: 'bg-oasis text-white' },
  { grade: 4, label: '轻松', color: 'bg-info text-white' },
];

/** 创建空卡片 */
export function newCard(): Card {
  return createEmptyCard(new Date());
}

/** 评分后更新卡片 */
export function reviewCard(card: Card, grade: SrsGrade): Card {
  const now = new Date();
  const result = f.repeat(card, now);
  // ts-fsrs 返回 { card, log }，取 card 部分
  return result[grade].card;
}

/** 获取今日待复习的卡片（due <= now） */
export function isDue(card: Card | undefined): boolean {
  if (!card) return true; // 无 SRS 数据 = 新词，需要学
  return card.due.getTime() <= Date.now();
}

/** 格式化下次复习时间 */
export function formatDue(card: Card | undefined): string {
  if (!card) return '新词';
  const due = card.due;
  const now = new Date();
  const diff = due.getTime() - now.getTime();
  const days = Math.floor(diff / (1000 * 60 * 60 * 24));
  const hours = Math.floor(diff / (1000 * 60 * 60));

  if (diff < 0) return '待复习';
  if (hours < 1) return '即将';
  if (hours < 24) return `${hours}小时后`;
  if (days < 30) return `${days}天后`;
  return `${Math.floor(days / 30)}个月后`;
}
